import { createContext, useContext, useState, useCallback } from "react";
import { dictionaries } from "./translations";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(
    () => localStorage.getItem("df_lang") || "pt-PT"
  );

  const setLang = useCallback((l) => {
    localStorage.setItem("df_lang", l);
    setLangState(l);
  }, []);

  const t = useCallback(
    (key, vars) => {
      const dict = dictionaries[lang] || {};
      let str = dict[key];
      if (str == null) str = dictionaries["pt-PT"][key];
      if (str == null) return key;
      if (vars) {
        Object.keys(vars).forEach((k) => {
          str = str.replace(`{${k}}`, vars[k]);
        });
      }
      return str;
    },
    [lang]
  );

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
